import { useTranslation } from "@/hooks/useTranslation";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { MessageCircleIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import NewMessageDrawerDialog from "../messages/NewMessageDrawerDialog";
import { ProfileViewResponse } from "@/generated-api";

export default function MessageButton({
  profileView,
  userId,
  className,
  isSelfView = false,
}: {
  profileView: ProfileViewResponse;
  userId: string;
  className?: string;
  isSelfView?: boolean;
}) {
  const [messageDrawerOpen, setMessageDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const t = useTranslation();

  return (
    <>
      {profileView.has_messaged ? (
        <Button
          variant="secondary"
          disabled={isSelfView}
          onClick={() => navigate("/messages/" + userId)}
          className={cn("rounded-full", className)}
        >
          <MessageCircleIcon className="h-6 w-6 mr-2 fill-black" />
          {t.PROFILE_VIEW.LABELS.VIEW_CHAT_BUTTON}
        </Button>
      ) : (
        <Button
          variant="secondary"
          disabled={isSelfView}
          onClick={() => setMessageDrawerOpen(true)}
          className={cn("rounded-full", className)}
        >
          <MessageCircleIcon className="h-6 w-6 mr-2 fill-black" />
          {t.PROFILE_VIEW.LABELS.MESSAGE_BUTTON}
        </Button>
      )}

      <NewMessageDrawerDialog
        open={messageDrawerOpen}
        profile={{
          profile_id: userId,
          display_name: profileView.display_name,
          photo_url: profileView.photos[0].photo_url,
          age: profileView.age,
          city_name: profileView.primary_city.name,
          country_alpha_2: profileView.primary_city.country.alpha_2,
          languages: profileView.languages,
        }}
        onClose={() => setMessageDrawerOpen(false)}
      />
    </>
  );
}
